"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultInitialStep = exports.characterIds = exports.directions = exports.bubbleModes = exports.choiceIds = exports.choiceTypes = exports.cameraEases = exports.cameraPresets = exports.characterMotionTypes = exports.labelColors = exports.editedBy = exports.filterPresets = void 0;
const types_1 = require("../../types/types");
exports.filterPresets = ['none', 'sepia', 'noise', 'crt', 'dots', 'film'];
exports.editedBy = ['bot', 'creator', 'migrator'];
exports.labelColors = ['blue', 'brown', 'green', 'orange', 'purple', 'red', 'teal', 'yellow'];
// enum objects are multidirectional so we need to filter out the actual values
exports.characterMotionTypes = Object.values(types_1.CharacterMotionType).filter(v => typeof (v) === 'number');
exports.cameraPresets = ['closeup', 'medium', 'cowboy', 'wide'];
exports.cameraEases = ['inOut1', 'shake'];
exports.choiceTypes = ['blue', 'premium'];
exports.choiceIds = ['a', 'b', 'c'];
exports.bubbleModes = ['character', 'scene'];
exports.directions = [1, -1];
exports.characterIds = ['a', 'b', 'c'];
exports.defaultInitialStep = 'DEFAULT_DIALOG!!!';
//# sourceMappingURL=consts.js.map